import { Routes } from '@angular/router';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent),
      },
      {
        path: 'price-lists',
        loadComponent: () => import('./features/ceniky/ceniky.component').then(m => m.CenikyComponent),
      },
      {
        path: 'transactions',
        loadComponent: () => import('./features/transakce/transakce.component').then(m => m.TransakceComponent),
      },
      {
        path: 'billing',
        loadComponent: () => import('./features/billing/billing.component').then(m => m.BillingComponent),
      },
      {
        path: 'reporting',
        loadComponent: () => import('./features/reporting/reporting.component').then(m => m.ReportingComponent),
      },
      {
        path: 'settings',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'tc-ui-demo',
        loadComponent: () => import('./features/tc-ui-demo/tc-ui-demo.component').then(m => m.TcUiDemoComponent),
      },
      // Legacy Czech URL redirects
      { path: 'ceniky', redirectTo: 'price-lists', pathMatch: 'full' },
      { path: 'transakce', redirectTo: 'transactions', pathMatch: 'full' },
      { path: 'nastaveni', redirectTo: 'settings', pathMatch: 'full' },
    ],
  },
];
